import React, { Component } from "react";
import { getSpk, getEnvironment } from "../../../../Redux/reducer/env";
import * as sessionActions from "../../../../Redux/actions/sessionActions";
import { connect } from "react-redux";
import {
  encryptPassword,
  loadingHtml,
  errorContainer,
} from "../../../utils/functions";
import { bindActionCreators } from "redux";
import Modal from "../../../utils/customModal";
import LoginBlock from "../templates/loginForm";
import AppName from "../../../../../static/images/appName.png";
import Chrome from "../../../../../static/images/chrome.png";
import Mozilla from "../../../../../static/images/mozilla.png";
import Explorer from "../../../../../static/images/explorer.svg";

export class Credentials extends Component {
  constructor(props) {
    super(props);
    this.state = { modal: false, content: null, onClose: undefined };
  }

  componentDidMount() {
    this.props.actions.setPage("");
  }

  validateUser = (_, refCode) => {
    const { register } = this.props.actions;

    if (/* authCode != "" && */ refCode != "") {
      /*  const encriptedauthCode = encryptPassword(authCode, this.props.spk); */
      const encriptedrefCode = encryptPassword(refCode, this.props.spk);
      this.setState({ modal: true, content: loadingHtml() });
      return register({
        /* authCode: encriptedauthCode, */
        refCode: encriptedrefCode,
      })
        .then(() => {
          this.setState({ modal: false, content: null });
          this.props.history.push("/credentials/reset");
        })
        .catch((e) => {
          // Errores de autenticación en caso de fallos del servicio
          this.setState({
            modal: true,
            content: errorContainer(
              "Datos incorrectos",
              e.response.data.notifications.shift().description,
              {
                continueBtn: {
                  action: () =>
                    this.setState({
                      modal: false,
                      content: null,
                      onClose: undefined,
                    }),
                  text: "Volver a intentar",
                },
              }
            ),
            onClose: () =>
              this.setState({
                modal: false,
                content: null,
                onClose: undefined,
              }),
          });
          return false;
        });
    }
  };

  render() {
    return (
      <div className="wrapper-login">
        <header className="main-login-header">
          <div className="login-header-container">
            <div className="container-item">
              <img src={AppName} alt="Nombre" />
            </div>
            <div className="browser">
              <p className="title">Sitio optimizado para:</p>
              <p className="browser-supported">
                <img src={Explorer} alt="Navegadores soportados" />{" "}
                IE 11+
              </p>
              <p className="browser-supported">
                <img src={Mozilla} alt="Navegadores soportados" />{" "}
                Mozilla Firefox
              </p>
              <p className="browser-supported">
                <img src={Chrome} alt="Navegadores soportados" />{" "}
                Google Chrome
              </p>
            </div>
          </div>
        </header>
        <div className="login-flex">
          <div className="formulario">
            <h1 className="init_session">Recuperación de Credenciales</h1>
            <h1 className="line red" />
            <h3 className="info_log">Ingrese el Número de referencia</h3>
            <LoginBlock
              onlyPassword
              lblUserpass={"Número de referencia"}
              lblActionBtn={"Confirmar"}
              btnAction={this.validateUser}
              env={this.props.env}
            />
            <Modal show={this.state.modal} handleClose={this.state.onClose}>
              {this.state.content}
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
    env: getEnvironment(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(sessionActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatch)(Credentials);
